<template>
  <div :class="$style.row">
    <ItemRow
      v-bind="$attrs"
      :selected="itemData.selected"
      v-on="$listeners"
    >
      <ItemWithLabel
        :class="$style.displayFlex"
        :column="columns[0]"
      >
        <Icon
          :class="$style.iconPosition"
          icon="deviceGroup"
          :scale="2"
        />
      </ItemWithLabel>
      <ItemWithLabel
        :column="columns[1]"
      >
        {{ itemData.name }}
      </ItemWithLabel>
      <ItemWithLabel
        :class="$style.marginLeftSpacer"
        :column="columns[2]"
      >
        {{ itemData.numberOfDevices }}
      </ItemWithLabel>
      <ItemWithLabel
        :class="$style.marginLeftSpacer"
        :column="columns[3]"
      >
        {{ itemData.defaultGroup }}
      </ItemWithLabel>
    </ItemRow>
  </div>
</template>

<script>
import {
  Icon,
  ItemRow,
  ItemWithLabel,
} from '@jumpcloud/ui-components';

export default {
  name: 'GoogleAppsDeviceGroupsRow',
  components: {
    Icon,
    ItemRow,
    ItemWithLabel,
  },

  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },
    itemData: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style module>
.row {
  border-bottom: var(--jc-border);
}

.marginLeftSpacer {
  margin-left: var(--jc-spacer);
}

.displayFlex {
  display: flex;
}

.itemLabelMarginLeft {
  margin-left: 2.063rem;
}

.itemLabelMarginRight {
  margin-right: 2.063rem;
}

.iconPosition {
  margin-top: -0.313rem;
}
</style>
